export default __webpack_public_path__ + "static/media/DinosaurSafari_09.5fc03153.png";